import { ReactElement } from 'react';

import { TypographyProps } from '@material-ui/core';
import { AlmeMinimizeConfig } from '../AlmeMinimize/AlmeMinimizeConfig';
import { AlmeMoreMenuConfig } from '../AlmeMoreMenu/AlmeMoreMenuConfig';

import minimizeConfig from '../AlmeMinimize/AlmeMinimizeConfig';
import moreMenuConfig from '../AlmeMoreMenu/AlmeMoreMenuConfig';
import closeConfig, { AlmeCloseConfig } from '../AlmeClose/AlmeCloseConfig';

import { AlmeColorProp } from '../../models/AlmeColorMapping';
import utilityBarConfig, { AlmeUtilityBarConfig } from "../AlmeUtilityBar/AlmeUtilityBarConfig";

interface HeaderConfig extends AlmeCloseConfig, AlmeMinimizeConfig, AlmeMoreMenuConfig, AlmeUtilityBarConfig {
    styles: {
        hasBorder: boolean;
        headerTextFont?: TypographyProps['variant'];
        backgroundColor?: AlmeColorProp;
    };
    headerIcon?: ReactElement;
}

export interface AlmeHeaderConfig {
    header: HeaderConfig;
}

/**
 * This is the baseline header config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see [appConfigMain](appConfigMain)
*/
const defaultConfig: AlmeHeaderConfig = {
    header: {
        ...minimizeConfig,
        ...moreMenuConfig,
        ...closeConfig,
        ...utilityBarConfig,
        styles: {
            hasBorder: false,
        },
    },
};

export default defaultConfig;
